export default "__VITE_ASSET__DNyjZj09__"